/* eslint-disable @typescript-eslint/no-explicit-any */
import UserImpersonationApi from '@portal/repositories/userImpersonation';
import * as MessageService from '~/services/message';

import { decreaseLoading, increaseLoading } from './loading';
import {
  USER_IMPERSONATION_LIST,
  USER_IMPERSONATION_LAST_ACCESS,
} from './actionTypes';

export const getUserImpersonationList = () => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await UserImpersonationApi.list();

    dispatch({
      payload,
      type: USER_IMPERSONATION_LIST,
    });

    return { payload };
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
    throw err;
  } finally {
    dispatch(decreaseLoading());
  }
};

export const getUserImpersonationLastAccess = () => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await UserImpersonationApi.myLastAccess();

    dispatch({
      payload,
      type: USER_IMPERSONATION_LAST_ACCESS,
    });

    return { payload };
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
    throw err;
  } finally {
    dispatch(decreaseLoading());
  }
};

export const acceptUserImpersonation =
  (id: string) => async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await UserImpersonationApi.accept(id);
      MessageService.success(
        'PAGES.AUTH.MULTI_ACCESS_SELECTION.MESSAGES.ACCEPTED'
      );

      await dispatch(getUserImpersonationList());
    } catch (err: any) {
      MessageService.error(err.message, { originalError: err });
      throw err;
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const rejectUserImpersonation =
  (id: string) => async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await UserImpersonationApi.reject(id);
      MessageService.success(
        'PAGES.AUTH.MULTI_ACCESS_SELECTION.MESSAGES.REJECTED'
      );
      // Refresh the list after rejecting
      await dispatch(getUserImpersonationList());
    } catch (err: any) {
      MessageService.error(err.message, { originalError: err });
      throw err;
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const requestUserImpersonation =
  (body: { impersonatorUserLogin: string; permissions: string[] }) =>
  async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await UserImpersonationApi.request(body);
      MessageService.success(
        'PAGES.MY_ACCOUNT.MULTI_ACCESS.INVITE_SENT_SUCCESS'
      );
    } catch (err: any) {
      MessageService.error(err.message, { originalError: err });
      throw err;
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const updateUserImpersonationPermissions =
  (
    id: string,
    body: { removePermissions?: string[]; addPermissions?: string[] }
  ) =>
  async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await UserImpersonationApi.updatePermissions(id, body);
      MessageService.success(
        'PAGES.MY_ACCOUNT.MULTI_ACCESS.PERMISSIONS_UPDATED_SUCCESS'
      );

      await dispatch(getUserImpersonationList());
    } catch (err: any) {
      MessageService.error(err.message, { originalError: err });
      throw err;
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const cancelUserImpersonation =
  (userId: string) => async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      await UserImpersonationApi.cancelUserImpersonation(userId);
      MessageService.success(
        'PAGES.MY_ACCOUNT.MULTI_ACCESS.USER_DELETED_SUCCESS'
      );

      await dispatch(getUserImpersonationList());
    } catch (err: any) {
      MessageService.error(err.message, { originalError: err });
      throw err;
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const getUserToAccess = (id: string) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await UserImpersonationApi.getUserToAccess(id);
    return { payload };
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
    throw err;
  } finally {
    dispatch(decreaseLoading());
  }
};
